import {
  AgencyRow,
  AgencyDetails,
  AgencyNameRow,
  AgencyName,
  AgencyTypeBadge,
  AgencySubtitle,
} from './TransferToAgencyModal.styles';
import { ineligibilityHint, type DirectoryAgency } from './types';

interface AgencyListItemProps {
  agency: DirectoryAgency;
  isSelected: boolean;
  onSelect: (id: string) => void;
}

function AgencyListItem({ agency, isSelected, onSelect }: AgencyListItemProps) {
  const isIneligible = agency.ineligibilityReasons.length > 0;
  const handleSelect = () => {
    if (isIneligible) return;
    onSelect(agency.identifier);
  };

  return (
    <AgencyRow
      $isSelected={isSelected}
      $isDisabled={isIneligible}
      onClick={handleSelect}
      aria-disabled={isIneligible}
      data-name={`agency-item-${agency.identifier}`}
    >
      <input
        type="radio"
        name="agency-selection"
        checked={isSelected}
        disabled={isIneligible}
        onChange={handleSelect}
      />
      <AgencyDetails>
        <AgencyNameRow>
          <AgencyName>{agency.name}</AgencyName>
          <AgencyTypeBadge data-name="agency-type-badge">
            {agency.type === 'conference' ? 'Conference' : 'Transfer'}
          </AgencyTypeBadge>
        </AgencyNameRow>
        {isIneligible && (
          <AgencySubtitle data-name="agency-ineligible-reason">
            {ineligibilityHint(agency.ineligibilityReasons)}
          </AgencySubtitle>
        )}
        {!isIneligible && agency.state != null && agency.distanceMi != null && (
          <AgencySubtitle>
            {agency.state} &middot; {agency.distanceMi} mi
          </AgencySubtitle>
        )}
      </AgencyDetails>
    </AgencyRow>
  );
}

export default AgencyListItem;
